/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Summary_OverdueInputs */



/**
* | output |
* | --- |
* | "{count} customer(s) overdue: a billing month ended without a bill. Someone needs to check." |
*
* @param {Partner_Summary_OverdueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_overdue = /** @type {((inputs: Partner_Summary_OverdueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_OverdueInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Kunde(n) überfällig: Ein Abrechnungsmonat endete ohne Rechnung. Bitte prüfen.`)
	return /** @type {LocalizedString} */ (`${i?.count} customer(s) overdue: a billing month ended without a bill. Someone needs to check.`)
});